/**
 * Confetti helper — used on Goals achievement + other celebration moments.
 * Reduced-motion aware: no-op if user prefers reduced motion.
 */
import confetti from "canvas-confetti";

export function celebrate({ durationMs = 2000, particleCount = 90 } = {}) {
  if (typeof window === "undefined") return;
  try {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  } catch {}

  const end = Date.now() + durationMs;
  const colors = ["#95BAEF", "#C3DAF4", "#1F7A2C", "#B6E0C4", "#F5C24A"];
  const frame = () => {
    confetti({
      particleCount: Math.max(6, Math.floor(particleCount / 15)),
      angle: 60, spread: 55, origin: { x: 0 }, colors,
    });
    confetti({
      particleCount: Math.max(6, Math.floor(particleCount / 15)),
      angle: 120, spread: 55, origin: { x: 1 }, colors,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  };
  frame();
}
